export const VIEW_CUSTOMER_APP = 'View_CustomerApp';
export const SELECT_USER = 'Select_User';
export const VIEW_DOCUMENTS = 'View_Documents';
export const VIEW_MULTI_SEARCH = 'View_Multi_Search';
